import type { Component } from 'vue'
import NdsIconShieldApplication from '@/components/NewDesignSystem/Icons/NdsIconShieldApplication.vue'
import NdsIconSupplier from '@/components/NewDesignSystem/Icons/NdsIconSupplier.vue'
import { type PerimeterDetails, PerimeterType, PerimeterTypeWithTag } from '@/contexts/perimeters/Perimeters.interfaces'

export const PERIMETER_TYPE_ICON_COMPONENTS: Partial<Record<PerimeterType, Component>> = {
  [PerimeterType.PROVIDER]: NdsIconSupplier,
  [PerimeterType.APPLICATION]: NdsIconShieldApplication,
}

export const PERIMETERS_ROUTE_NAME = 'perimeters_scores'

export const TAG_TYPE = 't'
export const PERIMETER_TYPE = 'p'

export const PERIMETER_NAME_MAX_LENGTH = 128
export const PERIMETER_IDENTIFIER_MIN_LENGTH = 2

// TODO WAL-2537: front mock returned by getPerimeter, remove once the V2 endpoint exists
export const inMemoryPerimeterDetails: PerimeterDetails = {
  id: 1,
  identifier: 'IAM.123',
  name: { fr: 'Nom du périmètre', en: 'Perimeter name' },
  type: PerimeterTypeWithTag.INTERNAL,
  description: {
    fr: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    en: 'Perimeter description',
  },
  parentPaths: [
    [
      { id: 10, name: { fr: 'Arbre 1', en: 'Tree 1' } },
      { id: 11, name: { fr: 'Groupement intermédiaire', en: 'Intermediate grouping' } },
      { id: 12, name: { fr: 'Nom du groupement', en: 'Grouping name' } },
    ],
    [
      { id: 20, name: { fr: 'Arbre 2', en: 'Tree 2' } },
      { id: 21, name: { fr: 'Nom du groupement', en: 'Grouping name' } },
    ],
  ],
}
